/**
 * Centralized department ID constants
 * Update here when BE changes department IDs
 */

export const DEPARTMENT_IDS = {
    BOARD_OF_DIRECTORS: 1,
    SALES: 2,
    ACCOUNT: 3,
    /** Legacy department named "MARKETING" (department_code MARKETING) */
    MARKETING: 4,
    FINANCE: 5,
    HUMAN_RESOURCE: 6,
    TECHNOLOGY: 7,
    DEVELOPMENT: 8,
    SALE_PARTNER: 9,
    /** Newer department named "Marketing" (department_code MKT, Keycloak group /Marketing) */
    MARKETING_MKT: 18,
} as const

/**
 * Marketing staff are split across two departments (4 and 18): filtering on
 * DEPARTMENT_IDS.MARKETING alone silently drops everyone in the newer one.
 */
export const MARKETING_DEPARTMENT_IDS: number[] = [
    DEPARTMENT_IDS.MARKETING,
    DEPARTMENT_IDS.MARKETING_MKT,
]

/** Departments offered when picking the employee in charge of a contact/lead. */
export const CONTACT_ASSIGNEE_DEPARTMENT_IDS: number[] = [
    DEPARTMENT_IDS.BOARD_OF_DIRECTORS,
    DEPARTMENT_IDS.ACCOUNT,
    DEPARTMENT_IDS.SALES,
    ...MARKETING_DEPARTMENT_IDS,
]

/** Department name → ID mapping for permission scope resolution */
export const DEPARTMENT_SCOPES = [
    {
        name: 'BOARD OF DIRECTORS',
        department_id: DEPARTMENT_IDS.BOARD_OF_DIRECTORS,
    },
    { name: 'SALES', department_id: DEPARTMENT_IDS.SALES },
    { name: 'ACCOUNT', department_id: DEPARTMENT_IDS.ACCOUNT },
    { name: 'MARKETING', department_id: DEPARTMENT_IDS.MARKETING },
    { name: 'FINANCE', department_id: DEPARTMENT_IDS.FINANCE },
    { name: 'HUMAN RESOURCE', department_id: DEPARTMENT_IDS.HUMAN_RESOURCE },
    { name: 'TECHNOLOGY', department_id: DEPARTMENT_IDS.TECHNOLOGY },
    { name: 'DEVELOPMENT', department_id: DEPARTMENT_IDS.DEVELOPMENT },
    { name: 'SALE PARTNER', department_id: DEPARTMENT_IDS.SALE_PARTNER },
    {
        name: 'BOARD OF MANAGEMENT',
        department_id: DEPARTMENT_IDS.BOARD_OF_DIRECTORS,
    },
] as const
